export default __webpack_public_path__ + "static/media/download-view-more.5f71e996.svg";